import Quill from 'quill';

const BlockEmbed = Quill.import("blots/block/embed");
const ATTACHMENT_WRAPPER_STYLE = `
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    background-color: #F8F9FB;
    border-radius: 4px;
    color: white;
    box-shadow: 0px 1px 2px rgba(45, 52, 63, 0.2);
    border: 1px solid rgb(235 240 248);
  `;

const DOWNLOAD_BUTTON_STYLE = `
  border: none; background-color: transparent; display: flex; justify-content: center; align-items: center; margin-right: 4px; padding: 0.1rem 0.4rem; cursor: pointer;
  `;

const DELETE_BUTTON_STYLE = `
  border: none; background-color: transparent; display: flex; justify-content: center; align-items: center; cursor: pointer; padding-right: 14px; padding-right: 19px;
`;

const DOWNLOAD_ICON_SVG = `
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_617_4)">
      <path
        d="M10 11.875V3.125"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.125 8.75L10 11.875L6.875 8.75"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_617_4">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

const FILE_ICON_SVG = `
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_617_16)">
      <path
        d="M15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.125C3.75 2.95924 3.81585 2.80027 3.93306 2.68306C4.05027 2.56585 4.20924 2.5 4.375 2.5H11.875L16.25 6.875V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5Z"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.875 2.5V6.875H16.25"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_617_16">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

const PAPERCLIP_SVG = `
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_153)">
      <path
        d="M11.25 5.625L5.39227 11.5798C5.18643 11.7918 5.07229 12.0763 5.07451 12.3718C5.07674 12.6674 5.19515 12.9501 5.40416 13.159C5.61317 13.368 5.89599 13.4862 6.19151 13.4883C6.48702 13.4904 6.77149 13.3762 6.98344 13.1702L13.9662 6.09117C14.3882 5.66917 14.6253 5.09681 14.6253 4.5C14.6253 3.9032 14.3882 3.33083 13.9662 2.90883C13.5442 2.48682 12.9718 2.24974 12.375 2.24974C11.7782 2.24974 11.2058 2.48682 10.7838 2.90883L3.8011 9.98859C3.17668 10.6233 2.82834 11.479 2.83197 12.3693C2.83559 13.2596 3.19089 14.1125 3.82045 14.7421C4.45002 15.3716 5.30286 15.7269 6.1932 15.7305C7.08353 15.7342 7.93924 15.3858 8.57391 14.7614L14.3438 9"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_153">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

const TRASH_ICON_SVG = `
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_617_9)">
      <path
        d="M16.875 4.375H3.125"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.125 8.125V13.125"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.875 8.125V13.125"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.625 4.375V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H5C4.83424 16.875 4.67527 16.8092 4.55806 16.6919C4.44085 16.5747 4.375 16.4158 4.375 16.25V4.375"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.125 4.375V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875H8.125C7.79348 1.875 7.47554 2.0067 7.24112 2.24112C7.0067 2.47554 6.875 2.79348 6.875 3.125V4.375"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_617_9">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

class AttachmentBlot extends BlockEmbed {
  static tagName: string;
  static blotName: string;
  static className: string;
  static fileName: string;
  static href: string;
  static id: number;
  static icons: {
    trash: string;
    file: string;
    download: string;
  };

  static create(options: {
    fileName: string;
    id: number;
    url: string;
    icons: {
      trash: string;
      file: string;
      download: string;
    };
  }) {
    const { fileName, id, url, icons } = options;
    this.fileName = fileName;
    this.id = id;
    this.href = url;
    this.icons = icons;

    const node = super.create("div");

    if (id) {
      node.innerHTML = this.attachmentHTML();
      node.setAttribute("id", id);
      node.style = ATTACHMENT_WRAPPER_STYLE;
    }

    return node;
  }

  static value(node: { getAttribute: (arg0: string) => any }) {
    return node.getAttribute("href");
  }

  static attachmentHTML() {
    const closeButton = `
       <button class="closeButton" onclick="
          function removeAttachmentNode(element) {
            if (element && element.parentElement) element.parentElement.remove();
          }

          removeAttachmentNode(this);" style="${DELETE_BUTTON_STYLE}">
          ${TRASH_ICON_SVG}
        </button>
    `;

    return `
        ${FILE_ICON_SVG}
        <span onclick="
        function download() {
          const downloadLink = document.createElement('a');
          downloadLink.href = '${this.href}';
          downloadLink.download = '${this.fileName}';
          downloadLink.click();
        }

        download();" href="${this.href}" download="${this.fileName}" style="flex: 1; text-overflow: ellipsis; white-space: nowrap; overflow-x: hidden; color: #2973E0; padding-left: 5px; cursor: pointer;">${this.fileName}</span>
        <button onclick="
          function download() {
            const downloadLink = document.createElement('a');
            downloadLink.href = '${this.href}';
            downloadLink.download = '${this.fileName}';
            downloadLink.click();
          }

          download();" style="${DOWNLOAD_BUTTON_STYLE}">
          ${DOWNLOAD_ICON_SVG}
        </button>
        ${closeButton}
    `;
  }
}

AttachmentBlot.tagName = "div";
AttachmentBlot.blotName = "attachment";
AttachmentBlot.className = "quill-upload-progress";

export default AttachmentBlot;
